export default function NotFound() {
  return (
    <div className="container text-center m-5">
      <h1>Not Found</h1>
      <p>Sorry, nothing here.</p>
    </div>
  );
}
